<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#007BFF"
      :is-full-page="true"
    >
    </loading>
    <base-header class="pb-6"> </base-header>
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header border-0">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">Menu</h3>
            </div>
          </div>
        </div>
        <div class="row starter-page">
          <div class="container-fluid ">
            <vue-content-loading
              v-if="!loaded"
              :width="300"
              :height="170"
              primary="#bdc3c7"
              secondary="#95a5a6"
            >
              <svg:rect x="20" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="0" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="0" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="15" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="15" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="30" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="30" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="45" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="45" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="60" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="60" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="75" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="75" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="90" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="90" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="105" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="105" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="120" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="120" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="80" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="140" y="135" rx="3" ry="3" width="50" height="8" />
              <svg:rect x="200" y="135" rx="3" ry="3" width="50" height="8" />

              <svg:rect x="20" y="150" rx="3" ry="3" width="110" height="8" />
              <circle cx="206" cy="155" r="5" />
              <circle cx="219" cy="155" r="5" />
              <circle cx="232" cy="155" r="5" />
              <circle cx="245" cy="155" r="5" />
            </vue-content-loading>

            <el-table
              :data="meals"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              v-if="loaded"
            >
              <template v-slot:empty>
                <span>No hay platillos registrados</span>
              </template>

              <el-table-column label="" prop="subgroup_id" width="100px">
                <template v-slot="{ row }">
                  <img
                    :src="row.image"
                    class="img-fluid"
                    style="max-width: 50px; max-height: 50px;"
                    alt="Imagen del platillo"
                  />
                </template>
              </el-table-column>

              <el-table-column
                label="Nombre"
                prop="subgroup_id"
                min-width="150px"
              >
                <template v-slot="{ row }">
                  <div>{{ row.name }}</div>
                </template>
              </el-table-column>

              <el-table-column label="Receta" prop="subgroup_id" width="180px">
                <template v-slot="{ row }">
                  <a
                    v-if="row.meal_id"
                    target="_blank"
                    :href="getRecipeUrl(row)"
                  >
                    <base-button
                      :type="
                        getRecipeButtonClass(row) === 'btn-warning'
                          ? 'warning'
                          : 'success'
                      "
                      class="btn-sm"
                      >{{ getRecipeButtonText(row) }}</base-button
                    >
                  </a>
                </template>
              </el-table-column>

              <el-table-column label="Estado" prop="subgroup_id" width="100px">
                <template v-slot="{ row }">
                  <div class="d-flex justify-content-right">
                    <base-switch
                      v-model="row.status"
                      type="primary"
                      on-text="Si"
                      off-text="No"
                      @change="changeStatus(row)"
                    ></base-switch>
                  </div>
                </template>
              </el-table-column>

              <el-table-column
                label="Opciones"
                prop="subgroup_id"
                width="180px"
              >
                <template v-slot="{ row }">
                  <div
                    class="justify-content-center justify-content-sm-between flex-wrap"
                  >
                    <base-button
                      type="info"
                      class="btn-sm"
                      @click="selectedMeal = row"
                    >
                      Ver detalles
                    </base-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <CustomModal
      :is-modal="selectedMeal != null"
      @closeModal="selectedMeal = null"
      :closeOuth="true"
      width="xlg"
    >
      <FoodcourtMeal
        :meal="selectedMeal"
        @onMealChange="onMealChange"
        @closeModal="selectedMeal = null"
      ></FoodcourtMeal>
    </CustomModal>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import CartaStatusGateway from "../../gateways/CartaStatusGateway";
import { VueContentLoading } from "vue-content-loading";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from "vue-loading-overlay";
import CustomModal from "../../components/CustomModal";
import "vue-loading-overlay/dist/vue-loading.css";
import FoodcourtMeal from "./FoodcourtMeal.vue";
import FoodcourdTwoMixin from "../../mixin/foodcourdTwoMixin";

export default {
  name: "ListRestaurants",
  mixins: [FoodcourdTwoMixin],
  components: {
    // BasePagination,
    VueContentLoading,
    FoodcourtMeal,
    CustomModal,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    flatPicker,
    Loading
  },
  data() {
    return {
      loaded: false,
      isLoading: false,
      selectedMeal: null,
      meals: [],
      restaurantId: null
    };
  },
  async mounted() {
    await this.loadMeals();
    this.loaded = true;
  },
  computed: {
    queriedData() {
      let result = this.meals;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      } else {
        if (this.searchQuery) {
          result = [];
        }
      }
      return result;
    }
  },
  methods: {
    onMealChange(meal) {
      this.meals = this.meals.map(m => {
        if (m.id === meal.id) {
          return meal;
        }
        return m;
      });
    },
    async changeStatus(row) {
      // Va por el backend de catering (que reenvia al backoffice) para que
      // quede registrado QUE USUARIO apago/prendio el plato. Antes iba
      // directo al backoffice y no habia atribucion posible.
      try {
        await CartaStatusGateway.cambiarStatus(row.id, {
          status: row.status,
          oldStatus: !row.status,
          mealName: row.name,
          restaurantId: this.restaurantId
        });
      } catch (e) {
        // El backoffice no acepto el cambio: el switch debe volver a la
        // realidad, no quedarse mostrando un estado que no ocurrio.
        row.status = !row.status;
        this.avisarErrorCambioStatus(e);
      }
    },
    /**
     * Antes esto SIEMPRE mostraba "No se pudo cambiar el estado del plato.
     * Intenta de nuevo." sin importar la causa (403/422/404/503/lo que sea),
     * asi que quien reportaba un problema no traia ningun dato util. El
     * backend (FoodcourtMealStatusController) ya manda un `reason` estable
     * en `payload` para los casos que el mismo detecta; para lo que no pasa
     * por ahi (ej. 404 de Laravel si el ID no matchea la ruta) se usa el
     * status HTTP crudo como respaldo.
     */
    avisarErrorCambioStatus(e) {
      const payload = e && e.response && e.response.data && e.response.data.payload;
      const status = (payload && payload.httpStatus) || (e && e.response && e.response.status);
      const reason = payload && payload.reason;

      if (reason === "SIN_TOKEN_BACKOFFICE" || reason === "TOKEN_BACKOFFICE_INVALIDO") {
        this.$notify({
          type: "danger",
          message: "Tu sesion con el backoffice vencio. Vuelve a iniciar sesion para poder editar la carta."
        });
        this.$router.push({ name: "login" });
        return;
      }

      if (status === 401) {
        // 401 "pelado" (sin payload/reason) es el auth:api de catering
        // (ver app/Exceptions/Handler.php:59-61, devuelve solo
        // {"error":"Unauthenticated."}) — no confundirlo con el token de
        // backoffice, que siempre viene con `reason` seteado arriba.
        this.$notify({
          type: "danger",
          message: "Tu sesion vencio. Vuelve a iniciar sesion."
        });
        this.$router.push({ name: "login" });
        return;
      }

      const mensajesPorReason = {
        SIN_COCINA: "Tu cuenta no tiene una cocina asociada. Contacta a soporte para que la revisen.",
        BACKOFFICE_NO_CONFIGURADO: "El backoffice no esta disponible en este ambiente. Contacta a soporte.",
        BACKOFFICE_NO_ALCANZABLE: "No se pudo contactar al backoffice. Intenta de nuevo en unos minutos.",
        BACKOFFICE_RECHAZO: "El backoffice rechazo el cambio (puede que el plato ya no exista o pertenezca a otro restaurante)."
      };

      const mensajesPorStatus = {
        404: "No se pudo identificar el plato (ID invalido). Reporta este caso a soporte con el nombre del plato.",
        403: "No tienes permiso para editar este plato.",
        422: "El plato o el cambio enviado no son validos.",
        503: "El servicio no esta disponible en este momento. Intenta de nuevo en unos minutos."
      };

      const message =
        (reason && mensajesPorReason[reason]) ||
        mensajesPorStatus[status] ||
        "No se pudo cambiar el estado del plato. Intenta de nuevo.";

      this.$notify({ type: "danger", message });
    },
    async loadMeals() {
      this.isLoading = true;
      const carta = await CartaStatusGateway.platos();
      this.restaurantId = carta.restaurant_id || null;
      this.meals = carta.meals || [];
      this.isLoading = false;
    },
    sortChange({ prop, order }) {
      if (prop) {
        this.meals.sort((a, b) => {
          let aVal = a[prop];
          let bVal = b[prop];
          if (order === "ascending") {
            return aVal > bVal ? 1 : -1;
          }
          return bVal - aVal ? 1 : -1;
        });
      } else {
        this.meals.sort((a, b) => {
          return a.id - b.id;
        });
      }
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep .el-table .cell {
  word-break: break-word !important;
}
</style>
